import { classColours } from 'app/frontend/types/custom/CharacterClass'
import { Heart, Lock } from 'lucide-react'
import { rankedChoiceIconClass } from './housingUi'
import type { DisplayOccupant } from './types'

type Props = {
  occupants: DisplayOccupant[]
  forceSummary?: 'full' | 'partial'
}

const PlotOccupantLabel = ({ occupants, forceSummary }: Props) => {
  const claimed = occupants.find((occupant) => occupant.status === 'claimed')
  const approved = occupants.find((occupant) => occupant.status === 'approved')
  const byRank = [1, 2, 3].map((rankedChoice) => ({
    rankedChoice,
    count: occupants.filter(
      (occupant) => occupant.ranked_choice === rankedChoice,
    ).length,
  }))

  if ((claimed || approved) && !forceSummary) {
    const occupant = claimed ?? approved
    return (
      <span className='flex min-w-0 items-center gap-1.5'>
        {claimed ? (
          <Lock className='h-3.5 w-3.5 shrink-0 text-info-foreground' />
        ) : (
          <Heart className='h-4 w-4 shrink-0 text-success-foreground' />
        )}
        <span
          className={`min-w-0 truncate ${
            occupant?.character.characterClass
              ? classColours[occupant.character.characterClass].text
              : ''
          }`}
        >
          {occupant?.character.name}
        </span>
      </span>
    )
  }

  if (!forceSummary) {
    const firstChoices = occupants.filter(
      (occupant) => occupant.ranked_choice === 1,
    )
    if (firstChoices.length === 1) {
      return (
        <span className='flex min-w-0 items-center gap-1'>
          <Heart className={`h-4 w-4 shrink-0 ${rankedChoiceIconClass(1)}`} />
          <span
            className={`min-w-0 truncate ${
              firstChoices[0].character.characterClass
                ? classColours[firstChoices[0].character.characterClass].text
                : ''
            }`}
          >
            {firstChoices[0].character.name}
          </span>
        </span>
      )
    }
  }

  if (occupants.length === 0 && !forceSummary) return null

  return (
    <span className='flex min-w-0 items-center gap-2'>
      {byRank.map(({ rankedChoice, count }) => {
        if (count === 0 && forceSummary !== 'full') return null

        return (
          <span key={rankedChoice} className='flex shrink-0 items-center gap-1'>
            <Heart
              className={`h-4 w-4 shrink-0 ${rankedChoiceIconClass(
                rankedChoice,
              )}`}
            />
            {count}
          </span>
        )
      })}
    </span>
  )
}

export default PlotOccupantLabel
